import React, {useEffect, useRef, useState} from 'react'
import {Box} from '@mui/material'
import {TIMER_FIT_MEDIA} from '../theme/feltTheme'
import Pause from '@mui/icons-material/Pause'
import PlayArrow from '@mui/icons-material/PlayArrow'

export default function PlaybackOverlay({playing, hasStarted, suddenDeath, observationKey, children}: {playing: boolean; hasStarted?: boolean; suddenDeath: boolean; observationKey: string; children?: React.ReactNode}) {
  const previous = useRef({playing, observationKey})
  const [showPlay, setShowPlay] = useState(false)
  useEffect(() => {
    const transitioned = !previous.current.playing && playing && previous.current.observationKey === observationKey
    previous.current = {playing, observationKey}
    if (!transitioned || suddenDeath) {
      setShowPlay(false)
      return
    }
    setShowPlay(true)
    const timeout = setTimeout(() => setShowPlay(false), 2000)
    return () => clearTimeout(timeout)
  }, [playing, observationKey, suddenDeath])
  const cue = playing ? showPlay && 'play' : hasStarted !== false && 'pause'
  const visibleCue = !suddenDeath && cue
  const PlaybackIcon = cue === 'play' ? PlayArrow : Pause
  return <Box sx={{position: 'relative', containerType: 'inline-size', [TIMER_FIT_MEDIA]: {containerType: 'size', height: '100%'}}}>
    <Box data-testid="countdown-background" sx={{opacity: visibleCue ? 0.18 : 1, [TIMER_FIT_MEDIA]: {height: '100%'}, display: 'grid', alignItems: 'start'}}>{children}</Box>
    {visibleCue && <Box data-testid="playback-overlay" data-cue={cue} aria-hidden="true" sx={{position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', pointerEvents: 'none', color: 'text.primary'}}>
      <PlaybackIcon sx={{width: '100%', height: '100%'}}/>
    </Box>}
  </Box>
}
